{
  "sidebar.navigationLabel": "Κύρια πλοήγηση",
  "sidebar.themeToggleLight": "Εναλλαγή σε φωτεινή λειτουργία",
  "sidebar.themeToggleDark": "Εναλλαγή σε σκοτεινή λειτουργία",
  "nav.main": "Κύριες ενότητες",
  "welcome.mapAria": "Διαδραστικός χάρτης ορίων αγροτεμαχίου",
  "welcome.locating": "Εντοπισμός τοποθεσίας...",
  "welcome.drawButtonAria": "Σχεδίαση νέου ορίου αγροτεμαχίου",
  "welcome.drawingHintKeyboard": "Πατήστε Escape για ακύρωση της σχεδίασης.",
  "welcome.drawingLiveArea": "Εκτιμώμενη έκταση: {area}",
  "welcome.drawingHintTouch": "Πατήστε για να τοποθετήσετε σημεία. Πατήστε το πρώτο σημείο για κλείσιμο.",
  "welcome.drawingHintTouchPan": "Χρησιμοποιήστε δύο δάχτυλα για μετακίνηση του χάρτη.",
  "welcome.drawingToolbarAria": "Εργαλεία σχεδίασης",
  "welcome.undoVertexAria": "Αναίρεση τελευταίου σημείου",
  "welcome.finishPolygonAria": "Κλείσιμο πολυγώνου και ολοκλήρωση σχεδίασης",
  "welcome.cancelDrawingAria": "Ακύρωση σχεδίασης",
  "welcome.undo": "Αναίρεση",
  "welcome.finish": "Ολοκλήρωση",
  "advisor.inputAria": "Κάντε μια ερώτηση στον σύμβουλο",
  "advisor.runSelectLabel": "Επιλέξτε αποθηκευμένη εκτέλεση προσομοίωσης",
  "advisor.deleteRun": "Διαγραφή αποθηκευμένης εκτέλεσης",
  "advisor.confirmDeleteRun": "Διαγραφή αυτής της αποθηκευμένης εκτέλεσης;",
  "advisor.runDeleted": "Η αποθηκευμένη εκτέλεση διαγράφηκε.",
  "satellite.ndviChartAria": "Διάγραμμα χρονοσειράς NDVI",
  "satellite.ndviMean": "Μέσος όρος NDVI",
  "field.dialogTitle": "Αποθήκευση νέου αγροτεμαχίου",
  "field.dialogArea": "Εκτιμώμενη έκταση: {size}",
  "field.dialogName": "Όνομα αγροτεμαχίου",
  "field.dialogNamePlaceholder": "Εισαγάγετε όνομα αγροτεμαχίου",
  "field.dialogCrop": "Καλλιέργεια",
  "field.dialogSaving": "Αποθήκευση...",
  "field.dialogSave": "Αποθήκευση αγροτεμαχίου",
  "kpi.groupLabel": "Σύνοψη απόδοσης αγροτεμαχίου",
  "kpi.ariaYield": "Εκτιμώμενη απόδοση {value}",
  "kpi.ariaProfit": "Εκτιμώμενο κέρδος {value}",
  "kpi.ariaHealth": "Υγεία αγροτεμαχίου {value}",
  "kpi.ariaCaptured": "Τελευταία λήψη εικόνας {value}",
  "sidebar.title": "AGROPTIMIZER",
  "sidebar.subtitle": "Σύστημα Ευφυούς Γεωργίας",
  "sidebar.lightMode": "Φωτεινό",
  "sidebar.darkMode": "Σκοτεινό",
  "sidebar.logout": "Αποσύνδεση",
  "sidebar.drawField": "+ Νέο Αγροτεμάχιο",
  "sidebar.yourFields": "Τα Αγροτεμάχιά σας",
  "sidebar.yourFieldsAria": "Άνοιγμα λίστας αγροτεμαχίων",
  "sidebar.units.imperial": "Αγγλικό",
  "sidebar.units.metric": "Μετρικό",
  "sidebar.sessionLanguage": "Γλώσσα",
  "sidebar.sessionUnits": "Μονάδες Μέτρησης",
  "common.retry": "Επανάληψη",
  "common.close": "Κλείσιμο",
  "common.cancel": "Ακύρωση",
  "prefs.unitsLabel": "Μονάδες Μέτρησης",
  "prefs.languagePlaceholder": "Επιλέξτε γλώσσα",
  "prefs.unitsPlaceholder": "Επιλέξτε μονάδες",
  "prefs.language.english": "English (US)",
  "prefs.language.greek": "Ελληνικά",
  "prefs.language.portuguese": "Português (Brasil)",
  "prefs.language.spanish": "Español",
  "prefs.required": "Επιλέξτε και τη γλώσσα και τις μονάδες μέτρησης πριν συνεχίσετε.",
  "params.title": "Ρυθμίσεις Προσομοίωσης",
  "params.fieldConditions": "Συνθήκες Αγρού",
  "params.irrigation": "Άρδευση",
  "params.irrigation.rainfed": "Ξηρική καλλιέργεια",
  "params.irrigation.irrigated": "Αρδευόμενη",
  "params.prevCrop": "Προηγ. Καλλιέργεια",
  "params.prevCrop.corn": "Καλαμπόκι",
  "params.prevCrop.soybean": "Σόγια",
  "params.prevCrop.wheat": "Σιτάρι",
  "params.prevCrop.rice": "Ρύζι",
  "params.prevCrop.cotton": "Βαμβάκι",
  "params.prevCrop.fallow": "Αγρανάπαυση",
  "params.prevCrop.sorghum": "Σόργο",
  "params.prevCrop.otherCereal": "Άλλο Σιτηρό",
  "params.prevCrop.otherLegume": "Άλλο Ψυχανθές",
  "params.prevCrop.smallGrains": "Μικρά Σιτηρά",
  "params.prevCrop.other": "Άλλο",
  "params.soilType": "Τύπος Εδάφους",
  "params.soilType.siltLoam": "Ιλυώδης άμμος",
  "params.soilType.sandyLoam": "Αμμώδης άμμος",
  "params.soilType.clayLoam": "Αργιλώδης άμμος",
  "params.soilType.siltyClayLoam": "Ιλυοαργιλώδης άμμος",
  "params.soilType.loamySand": "Αμμώδες έδαφος",
  "params.soilType.loam": "Άμμος",
  "params.soilType.clay": "Άργιλος",
  "params.soilType.sand": "Άμμος (καθαρή)",
  "params.soilType.silt": "Ιλύς",
  "params.soilType.sandyClayLoam": "Αμμοαργιλώδης άμμος",
  "params.soilType.siltyClay": "Ιλυώδης άργιλος",
  "params.soilType.muck": "Τύρφη",
  "params.soilOM": "Οργ. Υλικό (%)",
  "params.soilPH": "pH Εδάφους",
  "params.phosphorus": "Φώσφορος",
  "params.phosphorus.high": ">50 ppm",
  "params.phosphorus.medium": "36–50 ppm",
  "params.phosphorus.low": "25–35 ppm",
  "params.phosphorus.veryLow": "<25 ppm",
  "params.potassium": "Κάλιο",
  "params.potassium.high": ">175 ppm",
  "params.potassium.medium": "131–175 ppm",
  "params.potassium.low": "61–130 ppm",
  "params.potassium.veryLow": "<61 ppm",
  "params.management": "Στρατηγική Διαχείρισης",
  "params.plantMonth": "Μήνας Σποράς",
  "params.month.january": "Ιανουάριος",
  "params.month.february": "Φεβρουάριος",
  "params.month.march": "Μάρτιος",
  "params.month.april": "Απρίλιος",
  "params.month.may": "Μάιος",
  "params.month.june": "Ιούνιος",
  "params.month.july": "Ιούλιος",
  "params.month.august": "Αύγουστος",
  "params.month.september": "Σεπτέμβριος",
  "params.month.october": "Οκτώβριος",
  "params.month.november": "Νοέμβριος",
  "params.month.december": "Δεκέμβριος",
  "params.plantDay": "Ημέρα",
  "params.maturityGroup": "Ομάδα Ωρίμανσης",
  "params.relativeMaturity": "Σχετική Ωρίμανση (ημέρες)",
  "params.seedingRate": "Πυκνότητα Σποράς ({unit})",
  "params.rowSpacing": "Απόσταση Γραμμών ({unit})",
  "params.tillage": "Σύστημα Κατεργασίας",
  "params.tillage.conventional": "Συμβατική",
  "params.tillage.noTill": "Ακαλλιέργητη",
  "params.tillage.stripTill": "Ζωνική",
  "params.foliarFungicide": "Διαφυλλικό Μυκητοκτόνο",
  "params.seedTreatment": "Επενδεδυμένος Σπόρος",
  "params.foliarFert": "Διαφυλλική Λίπανση",
  "params.coverCrop": "Καλλιέργεια Κάλυψης",
  "params.apply": "Ναι",
  "params.no": "Όχι",
  "params.fertility": "Εφαρμοσμένη Λίπανση",
  "params.nitrogen": "Άζωτο ({unit})",
  "params.nitrogenSplit": "Κατανομή Αζώτου ({unit})",
  "params.nitrogenTotal": "Σύνολο:",
  "params.nitrogenSplitNote": "Το συνολικό N σε όλες τις δόσεις δεν μπορεί να υπερβεί τα {max} lb/ac — η ρύθμιση του ενός slider περιορίζει τα άλλα.",
  "params.cornTotalNExceeded": "Το συνολικό άζωτο {total} lb/ac υπερβαίνει το μέγιστο των {max} lb/ac. Μειώστε μία από τις δόσεις N πριν την εκτέλεση.",
  "params.nPreSpring": "Αζ. Προ-Άνοιξη",
  "params.nAtPlant": "Αζ. Στη Σπορά",
  "params.nPostPlant": "Αζ. Μετά τη Σπορά",
  "params.phosphorusRate": "Φώσφορος ({unit})",
  "params.potassiumRate": "Κάλιο ({unit})",
  "params.sulfurRate": "Θείο ({unit})",
  "params.economics": "Οικονομικά",
  "params.soybeanPrice": "Τιμή αναφοράς ΗΠΑ (NASS) — σόγια ({unit})",
  "params.cornPrice": "Τιμή αναφοράς ΗΠΑ (NASS) — καλαμπόκι ({unit})",
  "params.seedCostSoy": "Κόστος Σπόρου ($/140k)",
  "params.seedCostCorn": "Κόστος Σπόρου ($/80k)",
  "params.fixedCosts": "Σταθερά Έξοδα ({unit})",
  "params.fixedCosts.tooltip": "Γενικά έξοδα ανά στρέμμα που δεν αφορούν συγκεκριμένη εισροή — π.χ. ενοίκιο γης, ασφάλεια καλλιέργειας, μηχανήματα, εργατικά, καύσιμα, επισκευές.",
  "params.seedTreatmentCost": "Επένδυση Σπόρου ({unit})",
  "params.coverCropSeed": "Χειμερινό Φυτό Κάλυψης ({unit})",
  "params.dryingCost": "Κόστος Ξήρανσης ({unit})",
  "params.fertPrices": "Τιμές Λιπασμάτων ({unit})",
  "params.fertNitrogen": "Άζωτο",
  "params.fertPhosphorus": "Φώσφορος",
  "params.fertPotassium": "Κάλιο",
  "params.fertSulfur": "Θείο",
  "params.operations": "Εργασίες ({unit})",
  "params.convTillage": "Συμβατική Κατεργ.",
  "params.noTillPlanting": "Ακαλλιέργητη Σπορά",
  "params.stripTillCost": "Ζωνική",
  "params.applications": "Εφαρμογές ({unit})",
  "params.fungInsectApp": "Διαφυλλικό Μυκητοκτόνο/Εντομοκτόνο + Εφαρμογή",
  "params.fertApp": "Εφαρμογή Λιπάσματος",
  "params.foliarFertApp": "Διαφυλλικό Λίπασμα + Εφαρμογή",
  "params.saveEcon": "Αποθήκευση Οικονομικών",
  "params.runSim": "Εκτέλεση Προσομοίωσης",
  "params.running": "Εκτελείται...",
  "params.working": "Επεξεργασία...",
  "tabs.advisor": "Σύμβουλος",
  "tabs.satellite": "Επιθεώρηση",
  "welcome.title": "Κανένα Αγροτεμάχιο Δεν Έχει Επιλεγεί",
  "welcome.description": "Σχεδιάστε το όριο του αγροτεμαχίου στον δορυφορικό χάρτη, ή επιλέξτε ένα υπάρχον από την πλαϊνή μπάρα για να ξεκινήσετε την ανάλυση.",
  "welcome.drawBtn": "Σχεδίαση Νέου Αγροτεμαχίου",
  "advisor.chatPlaceholder": "Ρωτήστε τον γεωπόνο — μεγιστοποίηση κέρδους, κατάταξη παραγόντων απόδοσης, σύγκριση κατεργασίας...",
  "advisor.send": "Αποστολή",
  "advisor.welcome": "Γεια! Είμαι ο **Γεωπόνος AI** σας. Ρυθμίστε τις παραμέτρους στο δεξί πάνελ και εκτελέστε μια προσομοίωση για να ξεκινήσετε. Μπορώ να σας βοηθήσω να μεγιστοποιήσετε την απόδοση, να βελτιστοποιήσετε το κέρδος ή να αξιολογήσετε τον κίνδυνο σε διάφορα καιρικά σενάρια. Ή ανοίξτε την καρτέλα **Επιθεώρηση** για να ρυθμίσετε την παρακολούθηση του αγροτεμαχίου και να εντοπίζετε έγκαιρα τυχόν προβλήματα.",
  "advisor.engineStarting": "🚜 **Εκκίνηση μηχανής...** Συνήθως διαρκεί 2–3 λεπτά.",
  "advisor.paramsInvalid": "Οι παράμετροι δεν είναι έγκυρες — προσαρμόστε τις και δοκιμάστε ξανά.",
  "advisor.simResults": "**📊 Αποτελέσματα Προσομοίωσης**\n\nΑξιολογήθηκαν **{n_scenarios}** σενάρια σε **{n_weather_years}** έτη καιρικών δεδομένων.\n\n{'|'} Μέτρηση {'|'} Τιμή {'|'}\n{'|'}---{'|'}---{'|'}\n{'|'} Εκτιμώμενη Μέση Απόδοση {'|'} **{yield_value}** {'|'}\n{'|'} Εκτιμώμενο Κέρδος {'|'} **{profit_value}** {'|'}\n{'|'} Περιθώριο ανά Bushel {'|'} **{margin_value}** {'|'}\n\nΡωτήστε με να ερμηνεύσω τα αποτελέσματα, να μεγιστοποιήσω το κέρδος ή να κατατάξω τους κορυφαίους παράγοντες απόδοσης.",
  "advisor.simFailed": "❌ Η προσομοίωση απέτυχε: {error}",
  "simulation.completeToast": "Η προσομοίωση για το '{field}' ολοκληρώθηκε — {yield}",
  "simulation.failedToast": "Η προσομοίωση για το '{field}' απέτυχε.",
  "advisor.modifyInputs": "Τροποποίηση Εισροών",
  "advisor.hideInputs": "Απόκρυψη Εισροών",
  "advisor.avg": "μέσος",
  "advisor.noRuns": "Χωρίς εκτελέσεις",
  "satellite.range": "εύρος",
  "satellite.insightAria": "Σύνοψη υγείας αγρού",
  "satellite.insight.iconLabel": "Υγεία",
  "satellite.insight.firstImage": "Πρώτη εικόνα της σεζόν — θα παρακολουθούμε τις αλλαγές στις επόμενες διελεύσεις.",
  "satellite.insight.noStall": "Δεν εντοπίστηκε στασιμότητα — η βλάστηση του αγρού παρέμεινε σταθερή από την προηγούμενη καθαρή εικόνα.",
  "satellite.insight.flagged": "Το {pct}% του αγρού εμφανίζει στασιμότητα ανάπτυξης από την προηγούμενη εικόνα. Οι επισημασμένες περιοχές εμφανίζονται με κόκκινο πάνω στον χάρτη — εκτιμήστε το μέγεθος και τη θέση τους πριν αποφασίσετε αν αξίζει να κάνετε επιθεώρηση.",
  "satellite.insight.askAdvisor": "Ρωτήστε τον Σύμβουλο για αυτή την εικόνα",
  "advisor.autoPrompt.imageAnalysis": "Ανάλυσε τη δορυφορική εικόνα της {date} (DAP {dap}). Τι άλλαξε από την προηγούμενη εικόνα και τι πρέπει να προσέξω;",
  "advisor.autoPrompt.imageAnalysisNoDap": "Ανάλυσε τη δορυφορική εικόνα της {date}. Τι άλλαξε από την προηγούμενη εικόνα και τι πρέπει να προσέξω;",
  "advisor.autoPrompt.firstImageAnalysis": "Αυτή είναι η πρώτη δορυφορική εικόνα της σεζόν για αυτό το αγροτεμάχιο, από {date} (DAP {dap}). Ποιους βασικούς δείκτες πρέπει να παρακολουθώ από εδώ και πέρα και τι πρέπει να προσέξω σε αυτή την εικόνα;",
  "advisor.autoPrompt.firstImageAnalysisNoDap": "Αυτή είναι η πρώτη δορυφορική εικόνα της σεζόν για αυτό το αγροτεμάχιο, από {date}. Ποιους βασικούς δείκτες πρέπει να παρακολουθώ από εδώ και πέρα και τι πρέπει να προσέξω σε αυτή την εικόνα;",
  "satellite.state.noField.title": "Επιλέξτε ένα αγροτεμάχιο",
  "satellite.state.noField.body": "Σχεδιάστε ή ανοίξτε ένα αγροτεμάχιο από Τα Αγροτεμάχιά σας για να δείτε δορυφορική παρακολούθηση.",
  "satellite.state.awaitingFirstImage.title": "Παρακολούθηση ενεργή — αναμονή πρώτης εικόνας",
  "satellite.state.awaitingFirstImage.body": "Αναμονή της επόμενης διέλευσης του Sentinel-2. Η πρώτη σας εικόνα αναμένεται μέσα σε 5 ημέρες από την ημερομηνία έναρξης παρακολούθησης, εφόσον ο ουρανός είναι καθαρός. Οι διελεύσεις με συννεφιά παραλείπονται, οπότε σε περιόδους νεφοκάλυψης μπορεί να καθυστερήσει.",
  "satellite.state.monitoringActive.firstImageNote": "Η πρώτη εικόνα ήρθε. Θα έχουμε ένδειξη τάσης μετά την επόμενη καθαρή διέλευση.",
  "satellite.state.seasonComplete.title": "Η σεζόν ολοκληρώθηκε",
  "satellite.state.seasonComplete.body": "Το παράθυρο παρακολούθησης έκλεισε. Δείτε τη σεζόν παρακάτω ή σχεδιάστε την επόμενη στον Σύμβουλο.",
  "satellite.state.seasonComplete.cta": "Σχεδίαση επόμενης σεζόν",
  "satellite.envelope.preCanopy": "Πρώιμη κάλυψη φυλλώματος — ορισμένοι δείκτες ακόμα ανενεργοί. Η κάλυψη ανίχνευσης είναι μειωμένη μέχρι να κλείσει το φύλλωμα (περίπου DAP 30).",
  "satellite.envelope.lateLimited": "Όψιμη σεζόν — περιορισμένη ανίχνευση. Ορισμένοι δείκτες έχουν κλείσει τα παράθυρά τους — η απουσία ένδειξης εδώ δεν αποτελεί εγγύηση μηδενικού στρες.",
  "satellite.tooltip.stall.firstImage": "Πρώτη εικόνα — καμία τάση ακόμα",
  "satellite.tooltip.stall.none": "Χωρίς στασιμότητα",
  "satellite.tooltip.stall.pct": "Στασιμότητα: {pct}% του αγρού",
  "satellite.stallRegionsCaption": "Περιοχές στασιμότητας ανάπτυξης",
  "satellite.kpi.stall.firstImage": "Αναμονή τάσης",
  "satellite.kpi.stall.none": "Χωρίς στασιμότητα",
  "satellite.kpi.stall.flagged": "Εντοπίστηκε στασιμότητα",
  "satellite.monitoringTitle": "Παρακολούθηση Αγροτεμαχίου",
  "satellite.monitoringSubtitle": "Επιλέξτε το παράθυρο επιθεώρησης. Η επιθεώρηση ξεκινά το νωρίτερο 25 ημέρες μετά τη φύτευση. Νέες εικόνες και πληροφορίες θα εμφανίζονται καθώς γίνονται διαθέσιμες μέσα σε αυτή την περίοδο.",
  "satellite.monitoringPlantingDate": "Ημερομηνία φύτευσης: {date}",
  "satellite.editPlantingDateAria": "Επεξεργασία ημερομηνίας φύτευσης",
  "satellite.plantingDateSaveFailed": "Αδυναμία αποθήκευσης της νέας ημερομηνίας φύτευσης. Δοκιμάστε ξανά.",
  "satellite.monitoringRangeLabel": "Παράθυρο επιθεώρησης (ημέρες μετά τη φύτευση)",
  "satellite.monitoringStartLabel": "Έναρξη επιθεώρησης (ημέρες μετά τη φύτευση)",
  "satellite.monitoringEndLabel": "Λήξη επιθεώρησης (ημέρες μετά τη φύτευση)",
  "satellite.monitoringStartDate": "Έναρξη: {date}",
  "satellite.monitoringEndDate": "Λήξη: {date}",
  "satellite.monitoringWindowSummary": "Παράθυρο παρακολούθησης: {start} - {end} ({days} ημέρες)",
  "satellite.monitoringLockedSummary": "Η παρακολούθηση έχει κλειδώσει για αυτό το αγροτεμάχιο μέχρι να ολοκληρωθεί το παράθυρο επιθεώρησης.",
  "satellite.endAdjustLabel": "Προσαρμογή τέλους παραθύρου παρακολούθησης",
  "satellite.endAdjustHint": "Η ημερομηνία φύτευσης και η αρχή του παραθύρου έχουν κλειδωθεί γιατί έχει καταγραφεί η πρώτη δορυφορική εικόνα. Μπορείτε ακόμα να μετακινήσετε το τέλος του παραθύρου (έως 95 ημέρες από την αρχή).",
  "satellite.endAdjustSaving": "Αποθήκευση...",
  "satellite.endAdjustSaved": "Το παράθυρο ενημερώθηκε.",
  "satellite.endAdjustFailed": "Δεν ήταν δυνατή η ενημέρωση του τέλους του παραθύρου. Δοκιμάστε ξανά.",
  "satellite.monitoringStartBtn": "Έναρξη Παρακολούθησης",
  "satellite.stopMonitoringBtn": "Διακοπή Παρακολούθησης",
  "satellite.stopMonitoringConfirmBody": "Να σταματήσουν οι καθημερινοί δορυφορικοί έλεγχοι για αυτό το αγροτεμάχιο; Οι ήδη καταγεγραμμένες εικόνες παραμένουν στο ιστορικό. Μπορείτε να ξεκινήσετε νέα περίοδο αργότερα.",
  "satellite.stopMonitoringConfirm": "Διακοπή Παρακολούθησης",
  "satellite.stopMonitoringSuccess": "Η παρακολούθηση σταμάτησε για αυτό το αγροτεμάχιο.",
  "satellite.stopMonitoringFailed": "Δεν ήταν δυνατή η διακοπή της παρακολούθησης. Δοκιμάστε ξανά.",
  "satellite.monitoringSeasonEnded": "Αυτή η περίοδος έχει ολοκληρωθεί. Προσαρμόστε την ημερομηνία φύτευσης και το παράθυρο παραπάνω και ξεκινήστε νέα περίοδο.",
  "satellite.startNewSeason": "Έναρξη Νέας Περιόδου",
  "satellite.monitoringNotStarted": "Η Παρακολούθηση Δεν Ξεκίνησε",
  "satellite.monitoringScheduled": "Η Παρακολούθηση Προγραμματίστηκε",
  "satellite.monitoringComplete": "Η Παρακολούθηση Ολοκληρώθηκε",
  "satellite.monitoringMissingPlanting": "Επιλέξτε πρώτα ημερομηνία φύτευσης στο Advisor.",
  "satellite.latestImage": "Τελευταία Εικόνα",
  "satellite.dayAfterPlanting": "Ημέρα {dap} μετά τη φύτευση",
  "satellite.cloudCover": "Νέφωση",
  "satellite.ndviScale": "NDVI",
  "satellite.monitoringActive": "Παρακολούθηση Ενεργή",
  "satellite.connecting": "Σύνδεση με δορυφόρο...",
  "ndvi.preEmergence": "Προ-Φύτρωμα",
  "toast.error": "Σφάλμα",
  "toast.warning": "Προειδοποίηση",
  "toast.success": "Επιτυχία",
  "toast.info": "Πληροφορία",
  "help.title": "ΟΔΗΓΟΣ AGROPTIMIZER",
  "help.placeholder": "Ρωτήστε πώς να χρησιμοποιήσετε την εφαρμογή...",
  "help.send": "Αποστολή",
  "help.greeting": "Γεια! Είμαι ο οδηγός σας στο AGROPTIMIZER.\n\nΜπορώ να σας βοηθήσω με:\n• Πώς να σχεδιάσετε αγροτεμάχιο\n• Τι δείχνει κάθε καρτέλα\n• Εκτέλεση προσομοίωσης\n• Κατανόηση δορυφορικών εικόνων\n• Οτιδήποτε άλλο για την πλατφόρμα\n\nΣε τι χρειάζεστε βοήθεια;",
  "login.title": "AGROPTIMIZER",
  "login.subtitle": "Ευφυής Γεωργία",
  "login.tabLogin": "Σύνδεση",
  "login.tabRegister": "Εγγραφή",
  "login.email": "Email",
  "login.emailPlaceholder": "you{'@'}example.com",
  "login.password": "Κωδικός",
  "login.passwordPlaceholder": "••••••••",
  "login.loginBtn": "Σύνδεση",
  "login.forgotPassword": "Ξεχάσατε τον κωδικό;",
  "login.loggingIn": "Σύνδεση...",
  "login.loginFailed": "Αποτυχία σύνδεσης",
  "register.email": "Email",
  "register.emailPlaceholder": "you{'@'}example.com",
  "register.password": "Κωδικός",
  "register.passwordPlaceholder": "Ελάχιστο 8 χαρακτήρες",
  "register.confirmPassword": "Επιβεβαίωση Κωδικού",
  "register.confirmPlaceholder": "Επανάληψη κωδικού",
  "register.createBtn": "Δημιουργία Λογαριασμού",
  "register.creating": "Δημιουργία λογαριασμού...",
  "register.passwordMismatch": "Οι κωδικοί δεν ταιριάζουν",
  "register.failed": "Αποτυχία εγγραφής",
  "forgot.description": "Εισάγετε το email σας και θα σας στείλουμε σύνδεσμο επαναφοράς.",
  "forgot.email": "Email",
  "forgot.emailPlaceholder": "you{'@'}example.com",
  "forgot.sendBtn": "Αποστολή Συνδέσμου",
  "forgot.backToLogin": "← Πίσω στη Σύνδεση",
  "forgot.sending": "Αποστολή...",
  "forgot.sendFailed": "Αποτυχία αποστολής. Δοκιμάστε ξανά.",
  "forgot.linkSent": "Ο σύνδεσμος στάλθηκε.",
  "changePassword.title": "Αλλαγή Κωδικού",
  "changePassword.currentPassword": "Τρέχων Κωδικός",
  "changePassword.currentPlaceholder": "••••••••",
  "changePassword.newPassword": "Νέος Κωδικός",
  "changePassword.newPlaceholder": "Ελάχιστο 8 χαρακτήρες",
  "changePassword.confirmPassword": "Επιβεβαίωση Νέου Κωδικού",
  "changePassword.confirmPlaceholder": "Επανάληψη νέου κωδικού",
  "changePassword.changeBtn": "Αλλαγή Κωδικού",
  "changePassword.passwordMismatch": "Οι κωδικοί δεν ταιριάζουν",
  "changePassword.saving": "Αποθήκευση...",
  "changePassword.success": "Ο κωδικός άλλαξε! Ανακατεύθυνση...",
  "changePassword.failed": "Αποτυχία αλλαγής κωδικού",
  "satellite.nextImage.one": "Επόμενη εικόνα σε {days} ημέρα ({date})",
  "satellite.nextImage.other": "Επόμενη εικόνα σε {days} ημέρες ({date})",
  "validation.password.tooShort": "Ο κωδικός πρέπει να έχει τουλάχιστον 12 χαρακτήρες.",
  "validation.password.tooLong": "Ο κωδικός πρέπει να έχει το πολύ 72 χαρακτήρες.",
  "validation.password.common": "Αυτός ο κωδικός είναι από τους πιο διαδεδομένους σε διαρροές. Επιλέξτε κάτι πιο μοναδικό — μια σύντομη φράση ή πρόταση λειτουργεί καλά.",
  "validation.password.weak": "Ο κωδικός δεν είναι αρκετά ισχυρός.",
  "validation.password.criterion.length": "Τουλάχιστον 12 χαρακτήρες",
  "validation.password.criterion.notCommon": "Όχι κάποιος κοινόχρηστος κωδικός",
  "validation.password.show": "Εμφάνιση κωδικού",
  "validation.password.hide": "Απόκρυψη κωδικού",
  "error.auth.invalidCredentials": "Μη έγκυρο email ή κωδικός πρόσβασης",
  "error.auth.incorrectPassword": "Ο τρέχων κωδικός πρόσβασης είναι λανθασμένος",
  "error.auth.deleteConfirmationMismatch": "Πληκτρολογήστε DELETE (με κεφαλαία) για επιβεβαίωση.",
  "error.auth.externalAuth": "Αυτός ο λογαριασμός χρησιμοποιεί εξωτερική πιστοποίηση",
  "success.auth.accountDeleted": "Ο λογαριασμός διαγράφηκε.",
  "success.auth.subscriptionCancelled": "Η συνδρομή ακυρώθηκε.",
  "login.passwordRequired": "Απαιτείται κωδικός",
  "deleteAccount.title": "Διαγραφή Λογαριασμού",
  "deleteAccount.warning": "Ο λογαριασμός σας θα διαγραφεί. Τα αγροτεμάχια, η δορυφορική παρακολούθηση, οι προσομοιώσεις και το ιστορικό συζητήσεων θα διατηρηθούν για 30 ημέρες, σε περίπτωση που αλλάξετε γνώμη, και μετά θα διαγραφούν οριστικά. Συνδεθείτε ξανά μέσα στις 30 ημέρες για ακύρωση της διαγραφής.",
  "deleteAccount.typeToConfirm": "Πληκτρολογήστε DELETE για επιβεβαίωση",
  "deleteAccount.deleteBtn": "Διαγραφή λογαριασμού",
  "deleteAccount.deleting": "Διαγραφή...",
  "deleteAccount.failed": "Αδυναμία διαγραφής λογαριασμού.",
  "cancelSubscription.title": "Ακύρωση Συνδρομής",
  "cancelSubscription.body": "Το πλάνο σας θα επιστρέψει στη δωρεάν έκδοση. Μπορείτε να επανεγγραφείτε οποιαδήποτε στιγμή διατηρώντας τα αγροτεμάχια και το ιστορικό σας.",
  "cancelSubscription.keepPlan": "Διατήρηση πλάνου",
  "cancelSubscription.confirmBtn": "Επιβεβαίωση ακύρωσης",
  "cancelSubscription.cancelling": "Ακύρωση...",
  "cancelSubscription.success": "Η συνδρομή ακυρώθηκε.",
  "cancelSubscription.failed": "Αδυναμία ακύρωσης συνδρομής.",
  "changePassword.samePassword": "Ο νέος κωδικός πρέπει να είναι διαφορετικός από τον τρέχοντα.",
  "changePassword.weakPassword": "Ο κωδικός δεν είναι αρκετά ισχυρός.",
  "account.title": "Ο Λογαριασμός μου",
  "account.backToHome": "← Επιστροφή στην Αρχική",
  "account.navLabel": "Ενότητες λογαριασμού",
  "account.nav.profile": "Προφίλ",
  "account.nav.security": "Ασφάλεια",
  "account.nav.billing": "Χρεώσεις",
  "account.nav.dangerZone": "Ζώνη Κινδύνου",
  "account.profile.lede": "Βασικά στοιχεία λογαριασμού. Οι προτιμήσεις της περιόδου σύνδεσης ορίζονται κατά τη σύνδεση.",
  "account.profile.email": "Email",
  "account.profile.language": "Γλώσσα",
  "account.profile.units": "Μονάδες",
  "account.profile.plan": "Πακέτο",
  "account.profile.unitsImperial": "Αγγλοσαξονικές (acres, bu/ac)",
  "account.profile.unitsMetric": "Μετρικές (εκτάρια, kg/ha)",
  "account.profile.planFree": "Δωρεάν",
  "account.profile.languageChangeNote": "Επιλέξτε τη γλώσσα που θέλετε για την εφαρμογή, τα email και τον σύμβουλο AI. Η αλλαγή εφαρμόζεται αμέσως.",
  "account.profile.languageChangedToast": "Η γλώσσα ενημερώθηκε.",
  "account.profile.languageChangeFailedToast": "Δεν ήταν δυνατή η αλλαγή της γλώσσας. Δοκιμάστε ξανά.",
  "account.security.lede": "Ενημερώστε τον κωδικό σας. Η αλλαγή αποσυνδέει τις άλλες συσκευές σας.",
  "account.billing.lede": "Το τρέχον πακέτο συνδρομής σας.",
  "account.billing.paidDescription": "Έχετε πλήρη πρόσβαση στις λειτουργίες παρακολούθησης και συμβουλών.",
  "account.billing.freeDescription": "Βασική πρόσβαση. Αναβαθμίστε για εκτεταμένες λειτουργίες παρακολούθησης και συμβουλών.",
  "account.billing.freeLede": "Είστε στο δωρεάν πακέτο.",
  "account.billing.cancelCopy": "Υποβάθμιση στο δωρεάν πακέτο. Μπορείτε να αναβαθμίσετε ξανά οποτεδήποτε.",
  "account.dangerZone.lede": "Μη αναστρέψιμες ενέργειες. Ελέγξτε διπλά πριν επιβεβαιώσετε.",
  "account.dangerZone.deleteDescription": "Προγραμματίζει τον λογαριασμό σας για μόνιμη διαγραφή. Έχετε περίοδο χάριτος 30 ημερών για να τον επαναφέρετε επικοινωνώντας με την υποστήριξη.",
  "account.nav.connections": "Συνδεδεμένοι Λογαριασμοί",
  "account.connections.lede": "Συνδεθείτε γρηγορότερα συνδέοντας έναν εξωτερικό πάροχο ταυτότητας.",
  "account.connections.linked": "Συνδεδεμένο",
  "account.connections.notLinked": "Μη συνδεδεμένο",
  "account.connections.linkGoogle": "Σύνδεση Google",
  "account.connections.unlinkGoogle": "Αποσύνδεση Google",
  "account.connections.requiresVerifiedEmail": "Επαληθεύστε πρώτα το email σας για να συνδέσετε λογαριασμό Google.",
  "account.connections.linkSuccessToast": "Το Google συνδέθηκε με επιτυχία.",
  "account.connections.unlinkSuccessToast": "Το Google αποσυνδέθηκε.",
  "account.connections.linkDialog.title": "Συνδέστε τον λογαριασμό Google σας",
  "account.connections.linkDialog.body": "Επιβεβαιώστε τον κωδικό σας για να ξεκινήσετε τη σύνδεση του λογαριασμού Google. Θα ανακατευθυνθείτε στο Google για να παραχωρήσετε πρόσβαση.",
  "account.connections.linkDialog.password": "Τρέχων κωδικός πρόσβασης",
  "account.connections.linkDialog.continue": "Συνέχεια στο Google",
  "account.connections.linkDialog.linking": "Σύνδεση...",
  "account.connections.linkDialog.failed": "Δεν ήταν δυνατή η εκκίνηση της σύνδεσης Google. Δοκιμάστε ξανά.",
  "account.connections.unlinkDialog.title": "Αποσύνδεση Google",
  "account.connections.unlinkDialog.titleEmail": "Επιβεβαίωση μέσω email",
  "account.connections.unlinkDialog.bodyHybrid": "Επιβεβαιώστε τον κωδικό σας για να αποσυνδέσετε το Google από τον λογαριασμό σας. Θα συνεχίσετε να συνδέεστε με email και κωδικό.",
  "account.connections.unlinkDialog.bodyGoogleOnly": "Θα στείλουμε σύνδεσμο επιβεβαίωσης στο email σας. Κάντε κλικ σε αυτόν για να ορίσετε νέο κωδικό και να αποσυνδέσετε το Google. Χωρίς κωδικό θα χάνατε την πρόσβαση στον λογαριασμό σας.",
  "account.connections.unlinkDialog.password": "Τρέχων κωδικός πρόσβασης",
  "account.connections.unlinkDialog.confirm": "Αποσύνδεση",
  "account.connections.unlinkDialog.disconnecting": "Αποσύνδεση...",
  "account.connections.unlinkDialog.sendEmail": "Αποστολή email επιβεβαίωσης",
  "account.connections.unlinkDialog.sending": "Αποστολή...",
  "account.connections.unlinkDialog.emailSentToast": "Στείλαμε σύνδεσμο επιβεβαίωσης στο email σας.",
  "account.connections.unlinkDialog.failed": "Δεν ήταν δυνατή η αποσύνδεση του Google. Δοκιμάστε ξανά.",
  "account.connections.finalize.title": "Ορίστε κωδικό και αποσυνδέστε το Google",
  "account.connections.finalize.body": "Ορίστε κωδικό για τον λογαριασμό σας. Θα αποσυνδέσουμε το Google στο ίδιο βήμα.",
  "account.connections.finalize.newPassword": "Νέος κωδικός πρόσβασης",
  "account.connections.finalize.confirmPassword": "Επιβεβαίωση νέου κωδικού",
  "account.connections.finalize.confirm": "Αποσύνδεση Google",
  "account.connections.finalize.submitting": "Αποσύνδεση...",
  "account.connections.finalize.mismatch": "Οι κωδικοί δεν ταιριάζουν.",
  "account.connections.finalize.weak": "Ο κωδικός είναι πολύ αδύναμος.",
  "account.connections.finalize.failed": "Δεν ήταν δυνατή η αποσύνδεση του Google. Δοκιμάστε ξανά.",
  "common.cancel": "Ακύρωση",
  "login.oauthOr": "ή",
  "login.signInWithGoogle": "Σύνδεση με Google",
  "login.emailVerifiedToast": "Το email επαληθεύτηκε — ευχαριστούμε!",
  "login.emailVerifyFailedToast": "Ο σύνδεσμος επαλήθευσης είναι μη έγκυρος ή έχει λήξει. Συνδεθείτε για να ζητήσετε νέο.",
  "login.oauthError.cancelled": "Η σύνδεση μέσω Google ακυρώθηκε.",
  "login.oauthError.state": "Η συνεδρία σύνδεσης έληξε ή είναι μη έγκυρη. Δοκιμάστε ξανά.",
  "login.oauthError.token": "Δεν ήταν δυνατή η ολοκλήρωση της σύνδεσης Google. Δοκιμάστε ξανά.",
  "login.oauthError.deactivated": "Αυτός ο λογαριασμός έχει απενεργοποιηθεί.",
  "login.oauthError.emailConflict": "Υπάρχει ήδη λογαριασμός με αυτό το email. Συνδεθείτε με email/κωδικό και συνδέστε το Google από τις ρυθμίσεις λογαριασμού.",
  "login.oauthError.googleUnverified": "Το email του λογαριασμού Google δεν έχει επαληθευτεί. Επαληθεύστε το πρώτα με τη Google.",
  "login.oauthError.alreadyLinked": "Αυτός ο λογαριασμός Google είναι ήδη συνδεδεμένος με άλλον λογαριασμό AGROPTIMIZER.",
  "login.oauthError.linkToken": "Η συνεδρία σύνδεσης έληξε ή είναι μη έγκυρη. Επιβεβαιώστε ξανά τον κωδικό σας και δοκιμάστε ξανά.",
  "login.oauthError.linkUnauthenticated": "Συνδεθείτε πριν συνδέσετε λογαριασμό Google.",
  "login.oauthError.linkTarget": "Δεν βρέθηκε ο λογαριασμός σας. Συνδεθείτε ξανά και δοκιμάστε άλλη φορά.",
  "login.oauthError.generic": "Δεν ήταν δυνατή η σύνδεση μέσω Google. Δοκιμάστε ξανά.",
  "emailVerify.banner.text": "Στείλαμε σύνδεσμο επαλήθευσης στο email σας. Επαληθεύστε τη διεύθυνσή σας για να ξεκλειδώσετε τη σύνδεση λογαριασμών.",
  "emailVerify.banner.resend": "Δεν το λάβατε; Επαναποστολή",
  "emailVerify.banner.sending": "Αποστολή...",
  "emailVerify.banner.sent": "Στάλθηκε — δείτε τα εισερχόμενά σας",
  "emailVerify.banner.dismiss": "Απόρριψη",
  "emailVerify.banner.resentToast": "Στάλθηκε email επαλήθευσης. Δείτε τα εισερχόμενά σας.",
  "emailVerify.banner.resendFailed": "Δεν ήταν δυνατή η αποστολή του email επαλήθευσης. Δοκιμάστε ξανά σε λίγο.",
  "errors.notFound": "Τα ζητούμενα δεδομένα δεν βρέθηκαν.",
  "errors.server": "Ο διακομιστής δεν μπόρεσε να ολοκληρώσει το αίτημα. Δοκιμάστε ξανά.",
  "units.imperial.area": "ac",
  "units.imperial.yield": "bu/ac",
  "units.imperial.nutrient": "lb/ac",
  "units.imperial.seedingRate": "k/ac",
  "units.imperial.rowSpacing": "in",
  "units.imperial.costPerArea": "$/ac",
  "units.imperial.precipitation": "in",
  "units.imperial.temperature": "°F",
  "units.imperial.pricePerBu": "$/bu",
  "units.imperial.pricePerLb": "$/lb",
  "units.metric.area": "ha",
  "units.metric.yield": "kg/ha",
  "units.metric.nutrient": "kg/ha",
  "units.metric.seedingRate": "k/ha",
  "units.metric.rowSpacing": "cm",
  "units.metric.costPerArea": "$/ha",
  "units.metric.precipitation": "mm",
  "units.metric.temperature": "°C",
  "units.metric.pricePerBu": "$/t",
  "units.metric.pricePerLb": "$/kg",
  "crop.corn": "Καλαμπόκι",
  "crop.soybean": "Σόγια",
  "error.auth.registrationFailed": "Η εγγραφή απέτυχε. Ελέγξτε τα στοιχεία σας ή δοκιμάστε ένα διαφορετικό email.",
  "error.auth.invalidRefreshToken": "Μη έγκυρο ή ληγμένο refresh token",
  "error.auth.invalidTokenType": "Μη έγκυρος τύπος token",
  "error.auth.invalidToken": "Μη έγκυρο refresh token",
  "error.auth.userNotFound": "Ο χρήστης δεν βρέθηκε",
  "error.auth.tokenRevoked": "Το token έχει ανακληθεί",
  "error.auth.resetLinkInvalid": "Ο σύνδεσμος επαναφοράς είναι μη έγκυρος ή έχει λήξει.",
  "error.field.notFound": "Το αγροτεμάχιο δεν βρέθηκε",
  "error.field.tooLarge": "Το αγροτεμάχιο είναι πολύ μεγάλο ({acres} στρέμματα). Μέγιστο επιτρεπτό {max_acres} στρέμματα ανά αγροτεμάχιο.",
  "error.job.notFound": "Η εργασία δεν βρέθηκε",
  "error.job.notCancelable": "Η εργασία με κατάσταση {status} δεν μπορεί να ακυρωθεί.",
  "error.sim.fieldNotFound": "Το αγροτεμάχιο δεν βρέθηκε",
  "error.sim.tooManyJobs": "Πολλές εργασίες σε εξέλιξη ({count}). Παρακαλώ περιμένετε να ολοκληρωθούν οι τρέχουσες εργασίες.",
  "error.sim.resultNotFound": "Το αποτέλεσμα προσομοίωσης δεν βρέθηκε",
  "error.ndvi.fieldNotFound": "Το αγροτεμάχιο δεν βρέθηκε",
  "error.ndvi.cooldown": "Ανάκτηση πριν από {days_since} ημέρες. Ο δορυφόρος Sentinel-2 επιστρέφει κάθε ~5 ημέρες - επόμενη ανάκτηση διαθέσιμη {next_date}.",
  "error.ndvi.invalidDate": "Μη έγκυρη μορφή ημερομηνίας. Χρησιμοποιήστε ΕΕΕΕ-ΜΜ-ΗΗ.",
  "error.ndvi.imageNotAvailable": "Η εικόνα δεν είναι διαθέσιμη για αυτήν την ημερομηνία.",
  "error.ndvi.imageCleanedUp": "Το αρχείο εικόνας έχει διαγραφεί.",
  "error.ndvi.invalidMonitoringDays": "Οι ημέρες παρακολούθησης πρέπει να είναι μεταξύ {min_days} και {max_days}.",
  "error.market.fieldNotFound": "Το αγροτεμάχιο δεν βρέθηκε",
  "error.market.contractNotFound": "Το συμβόλαιο δεν βρέθηκε",
  "error.llm.fieldNotFound": "Το αγροτεμάχιο δεν βρέθηκε ή δεν έχετε πρόσβαση.",
  "error.llm.threadNotFound": "Το νήμα συνομιλίας δεν βρέθηκε ή δεν έχετε πρόσβαση.",
  "error.llm.helpUnavailable": "Η βοήθεια συνομιλίας δεν είναι προσωρινά διαθέσιμη.",
  "error.rateLimit.tooMany": "Πολλά αιτήματα. Παρακαλώ περιμένετε ένα λεπτό.",
  "error.rateLimit.auth": "Πολλές προσπάθειες. Παρακαλώ περιμένετε ένα λεπτό.",
  "success.auth.passwordChanged": "Ο κωδικός άλλαξε επιτυχώς",
  "success.auth.loggedOut": "Αποσυνδεθήκατε επιτυχώς",
  "success.auth.resetLinkSent": "Αν αυτό το email είναι εγγεγραμμένο, στάλθηκε σύνδεσμος επαναφοράς.",
  "success.auth.passwordReset": "Ο κωδικός επαναφέρθηκε επιτυχώς. Μπορείτε τώρα να συνδεθείτε.",
  "success.ndvi.jobInProgress": "Μια δορυφορική ανάλυση είναι ήδη σε εξέλιξη για αυτό το αγροτεμάχιο.",
  "success.ndvi.monitoringStopped": "Η παρακολούθηση σταμάτησε επιτυχώς.",
  "success.ndvi.noMonitoring": "Δεν βρέθηκε ενεργή παρακολούθηση.",
  "success.market.refreshQueued": "Όλες οι εργασίες ανανέωσης αγοράς και AMS ξεκίνησαν επιτυχώς.",
  "status.job.started": "Ξεκίνησε",
  "status.job.complete": "Ολοκληρώθηκε",
  "status.job.retryingGeneric": "Επανάληψη",
  "status.job.failedGeneric": "Η εργασία απέτυχε. Δοκιμάστε ξανά.",
  "status.ndvi.noImagery": "Δεν βρέθηκε καθαρή εικόνα στο πρόσφατο διάστημα.",
  "common.unknown": "Άγνωστο",
  "fields.loading": "Φόρτωση αγροτεμαχίων...",
  "fields.empty": "Δεν υπάρχουν αγροτεμάχια ακόμα. Σχεδιάστε ένα όριο για να δημιουργήσετε νέο.",
  "fields.rename": "Μετονομασία",
  "fields.delete": "Διαγραφή",
  "fields.renamePrompt": "Εισάγετε νέο όνομα για αυτό το αγροτεμάχιο:",
  "fields.deleteConfirm": "Θέλετε σίγουρα να διαγράψετε το \"{name}\";",
  "kpi.estYield": "Εκτ. Απόδοση",
  "kpi.estProfit": "Εκτ. Κέρδος",
  "kpi.fieldHealth": "Υγεία Αγρού",
  "kpi.lastCaptured": "Τελευταία Λήψη",
  "kpi.growthSignal": "Σήμα ανάπτυξης",
  "kpi.today": "Σήμερα",
  "kpi.dayAgo": "1 ημέρα πριν",
  "kpi.daysAgo": "{n} ημέρες πριν",
  "kpi.ariaBreakeven": "Περιθώριο νεκρού σημείου {value}",
  "kpi.marginTooltip": "Το περιθώριο ανά μπούσελ είναι αυτό που κερδίζετε σε κάθε μπούσελ αφού καλύψετε τα κόστη σας. Είναι η τιμή της σοδειάς μείον την τιμή νεκρού σημείου. Το νεκρό σημείο είναι το συνολικό σας κόστος ανά στρέμμα διαιρεμένο με την αναμενόμενη απόδοση.",
  "advisor.you": "Εσείς",
  "advisor.replyUnavailable": "Λυπάμαι, δεν μπόρεσα να δημιουργήσω απάντηση.",
  "advisor.replyFailed": "Λυπάμαι, κάτι πήγε στραβά κατά τη δημιουργία της απάντησης. Δοκιμάστε ξανά.",
  "advisor.replyError": "Λυπάμαι, παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά.",
  "satellite.condition": "Κατάσταση",
  "satellite.daysAfterPlantingShort": "ΗΜΦ",
  "satellite.ndviUpdatedNudge": "Δορυφορικές εικόνες ενημερώθηκαν για αυτό το αγροτεμάχιο. Τελευταία παρατήρηση: πρασινάδα καλλιέργειας={mean}, κατάσταση=\"{label}\". Ρωτήστε με οτιδήποτε για την υγεία της καλλιέργειας ή τις τάσεις πρασινάδας.",
  "help.open": "Άνοιγμα βοήθειας",
  "help.errorReply": "Λυπάμαι, κάτι πήγε στραβά. Δοκιμάστε ξανά.",
  "login.success": "Η σύνδεση ολοκληρώθηκε.",
  "register.success": "Ο λογαριασμός δημιουργήθηκε.",
  "market.breakeven.margin": "Περιθώριο",
  "common.maxShort": "ΜΕΓ.",
  "simulation.submitting": "Υποβολή προσομοίωσης...",
  "simulation.running": "Εκτέλεση προσομοίωσης...",
  "simulation.loadingResults": "Φόρτωση αποτελεσμάτων...",
  "satellite.noField": "Δεν έχει επιλεγεί αγροτεμάχιο",
  "satellite.today": "Σήμερα",
  "satellite.oneDayAgo": "1 ημέρα πριν",
  "satellite.daysAgo": "{n} ημέρες πριν",
  "satellite.monitoringWaitHint": "Η παρακολούθηση θα φορτώσει αυτόματα νέα εικονοληπτικά δεδομένα όταν είναι διαθέσιμα.",
  "home.title": "Τα Αγροτεμάχιά σας",
  "home.subtitle": "Ποιο χωράφι χρειάζεται προσοχή;",
  "home.mapTitle": "Χάρτης αγροτεμαχίων",
  "home.mapAriaLabel": "Χάρτης επισκόπησης των αγροτεμαχίων σας",
  "home.lastObserved": "Τελευταία εικόνα {date}",
  "home.noObservation": "Δεν υπάρχει παρατήρηση ακόμα",
  "home.status.stall_detected": "Εντοπίστηκε στασιμότητα — ανοίξτε τον χάρτη για να ελέγξετε {area} που επισημάνθηκαν από την προηγούμενη εικόνα",
  "home.status.on_track": "Η υγεία της καλλιέργειας φαίνεται καλή",
  "home.status.monitoring_active": "Παρακολούθηση ενεργή — αναμονή δεδομένων τάσης",
  "home.status.stale": "Καμία καθαρή εικόνα εδώ και {n} ημέρες — ελέγξτε ξανά σύντομα",
  "home.status.no_observations": "Αναμονή πρώτης δορυφορικής εικόνας",
  "home.status.low_confidence": "Η πρόσφατη εικόνα ήταν μερικώς νεφοσκεπής — περιορισμένη ορατότητα",
  "home.empty.title": "Προσθέστε το πρώτο σας αγροτεμάχιο",
  "home.empty.subtitle": "Σχεδιάστε ένα όριο στον δορυφορικό χάρτη για να δημιουργήσετε αγροτεμάχιο.",
  "home.empty.action": "Δημιουργία Αγροτεμαχίου",
  "home.loading": "Φόρτωση αγροτεμαχίων...",
  "home.loadError": "Δεν ήταν δυνατή η φόρτωση αγροτεμαχίων. Δοκιμάστε ξανά.",
  "home.newField": "+ Νέο Αγροτεμάχιο",
  "home.totalArea": "Σύνολο: {area} σε {n} αγροτεμάχια",
  "field.created": "Το αγροτεμάχιο δημιουργήθηκε με επιτυχία",
  "field.createFailed": "Η δημιουργία του αγροτεμαχίου απέτυχε",
  "welcome.drawingHint": "Κάντε κλικ στον χάρτη για να τοποθετήσετε σημεία. Κάντε κλικ στο πρώτο σημείο για να κλείσετε το πολύγωνο.",
  "login.invalidEmail": "Μη έγκυρη μορφή email",
  "login.lockedOut": "Δοκιμάστε ξανά σε {seconds}δ",
  "satellite.growthFromPrevToSelected": "Ανάπτυξη από {prev} έως {selected}",
  "satellite.ndviTimeSeries": "Χρονοσειρά NDVI",
  "sidebar.toggle": "Εναλλαγή μενού",
  "common.yes": "Ναι",
  "params.foliarFertAppCost": "Εφαρμογή Φυλλικού Λιπάσματος",
  "advisor.sidebar.title": "Συνομιλίες",
  "advisor.sidebar.aria": "Συνομιλίες",
  "advisor.sidebar.sims": "Προσομοιώσεις",
  "advisor.sidebar.images": "Εικόνες",
  "advisor.sidebar.untitled": "Προσομοίωση χωρίς τίτλο",
  "advisor.sidebar.untitledSeason": "Σεζόν χωρίς τίτλο",
  "advisor.sidebar.rename": "Μετονομασία",
  "advisor.sidebar.delete": "Διαγραφή",
  "advisor.sidebar.confirmDelete": "Διαγραφή;",
  "advisor.sidebar.empty": "Εκτελέστε μια προσομοίωση ή πατήστε «Ρωτήστε τον Σύμβουλο για αυτή την εικόνα» για να ξεκινήσετε μια συνομιλία.",
  "advisor.relTime.justNow": "μόλις τώρα",
  "advisor.relTime.minutesAgo": "πριν {n}λ",
  "advisor.relTime.hoursAgo": "πριν {n}ώ",
  "advisor.relTime.daysAgo": "πριν {n}η",
  "advisor.divider.simFallback": "Προσομοίωση",
  "advisor.divider.imageFallback": "Εικόνα",
  "advisor.inputGate.preData": "Εκτελέστε μια προσομοίωση ή πατήστε «Ρωτήστε τον Σύμβουλο για αυτή την εικόνα» για να ξεκινήσετε μια συνομιλία.",
  "advisor.openRail": "Άνοιγμα συνομιλιών",
  "reset.description": "Ορίστε νέο κωδικό πρόσβασης για τον λογαριασμό σας.",
  "reset.newPassword": "Νέος κωδικός πρόσβασης",
  "reset.confirmPassword": "Επιβεβαίωση νέου κωδικού",
  "reset.confirmPlaceholder": "Επαναλάβετε τον νέο κωδικό",
  "reset.submit": "Ορισμός νέου κωδικού",
  "reset.submitting": "Ενημέρωση...",
  "reset.success": "Ο κωδικός ενημερώθηκε. Συνδεθείτε με τον νέο σας κωδικό.",
  "reset.failed": "Δεν ήταν δυνατή η επαναφορά του κωδικού. Ο σύνδεσμος μπορεί να έχει λήξει — ζητήστε νέον.",
  "reset.tokenMissing": "Ο σύνδεσμος επαναφοράς λείπει ή δεν είναι έγκυρος. Ζητήστε νέον.",
  "validation.password.criteriaLabel": "Απαιτήσεις κωδικού πρόσβασης"
}
